import React from "react";
import "./styles.css";
import Meme from "./components/MemeComponent";

export default function App() {
  return (
    <>
      <Meme />
    </>
  );
}

